import { render, staticRenderFns } from "./EstimatesAddEdit.vue?vue&type=template&id=5b1c7e74&scoped=true&"
import script from "./EstimatesAddEdit.vue?vue&type=script&lang=js&"
export * from "./EstimatesAddEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1c7e74",
  null
  
)

export default component.exports